var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-overlay",
    { attrs: { show: _vm.show }, on: { click: _vm.closeGuide } },
    [
      _c("div", { staticClass: "guide_item", style: { top: _vm.top } }, [
        _c("div", { staticClass: "selTxt" }, [
          _vm._v(_vm._s(_vm.selCountryInfo.content))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "guide_desc" }, [
          _vm._v(_vm._s(_vm.$t("m.EnterIDTip", { msg: _vm.getAppName() })))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08dfadc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08dfadc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guide.vue
// module id = null
// module chunks = 